function Layout({ children }) {
  return <main>{children}</main>;
}

export default Layout;
